export const SentryErrorQueue = {
    queue: [],
    maxItems: 50,

    init() {
        const savedQueue = localStorage.getItem('sentryErrorQueue');
        if (savedQueue) {
            this.queue = JSON.parse(savedQueue).filter(item => {
                // Фильтруем старые ошибки (старше 24 часов)
                return new Date() - new Date(item.timestamp) < 86400000;
            });
        }
    },

    add(errorData) {
        if (this.queue.length >= this.maxItems) {
            this.queue.shift(); // Удаляем самую старую ошибку
        }

        this.queue.push({
            ...errorData,
            timestamp: new Date().toISOString()
        });

        localStorage.setItem('sentryErrorQueue', JSON.stringify(this.queue));
    },

    async process() {
        if (!navigator.onLine || this.queue.length === 0) return;

        const successItems = [];

        for (const item of this.queue) {
            try {
                if (item.type === 'message') {
                    await window.Sentry.captureMessage(item.message, item.options);
                } else {
                    await window.Sentry.captureException(item.error, item.options);
                }
                successItems.push(item);
            } catch (e) {
                console.error('Failed to send error to Sentry:', e);
                break;
            }
        }

        // Удаляем успешно отправленные ошибки
        this.queue = this.queue.filter(item => !successItems.includes(item));
        localStorage.setItem('sentryErrorQueue', JSON.stringify(this.queue));
    }
};
